import { Avatar, Box, Link, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AppBarMenuButtonContext } from './app-bar-menu-button';
import { PopperNavigationContext } from '..';

const MenuLinkWithIcon = ({ link: { icon, title, subtitle, href }, sx, ...props }) => {

    const { t } = useTranslation('public');
    const navigate = useNavigate();

    const appBarContext = useContext(AppBarMenuButtonContext);
    const popperContext = useContext(PopperNavigationContext);

    return (
        <Box {...props} sx={{ ...sx, display: 'flex', flexDirection: 'row', alignItem: 'flex-start' }}>
            <Avatar src={icon} style={{ backgroundColor: '#ECF2F9', width: 32, height: 32, padding: 8, borderRadius: '16px' }} />
            <Box sx={{ marginInlineStart: 2, display: 'flex', flexDirection: 'column' }}>
                <Link
                    onClick={() => {
                        appBarContext?.handleClose()
                        popperContext?.closePopperMenu()
                        navigate(href)
                    }}
                    sx={{ textDecoration: 'none', cursor: href ? 'pointer' : 'auto' }}>
                    <Typography sx={{ color: "#1E1E1E", fontSize: '16px', fontStyle: 'normal', fontWeight: 500, whiteSpace: "nowrap", ":hover": { color: '#0B6296' } }}>
                        {t(title)}
                    </Typography>
                </Link>
                {
                    subtitle ?
                        <Typography sx={{ maxWidth: '250px', mt: 0.5, color: "#1E1E1E", fontSize: '14px', fontStyle: 'normal', fontWeight: 300, lineHeight: 'normal' }}>
                            {t(subtitle)}
                        </Typography>
                        : null
                }
            </Box>
        </Box>
    );
}

export default MenuLinkWithIcon;
